// extracted by mini-css-extract-plugin
module.exports = {"headlineContainer":"Headline_headlineContainer__2BRpc","headlineContainerEdit":"Headline_headlineContainerEdit__273Gs","headline":"Headline_headline__1VaK6"};